<p-panelMenu [model]="mobile_menu"> </p-panelMenu>
<div class="menu-footer" [class]="user?.role !== 'LD' ? 'mt-3' : null">
  <a href="mailto:mentoring@femmepalette.com" class="item"> Contact us </a>
  <hr />
  <button (click)="this.signOut()" class="item p-button-text button-menu">Log out</button>
</div>
